import React from 'react'
import BaseComponent from './BaseContainer'
import HomeLayout from '../layout/HomeLayout'

export default class HomeContainer extends BaseComponent {

  render() {
    return (
      <HomeLayout />
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/HomeContainer.js